var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.caption)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.caption)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }